import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "frontend-components";
import { useTranslation } from "react-i18next";
import type { Announcement } from "@dashboard/api/task";
import { announcementIconMap } from "./announcementIconMap";
import { AnnouncementReactionPreview } from "./AnnouncementReactionPreview";

interface AnnouncementItemProps {
    announcement: Announcement;
    onClick: (announcement: Announcement) => void;
}

export function AnnouncementItem({ announcement, onClick }: AnnouncementItemProps) {
    const { i18n } = useTranslation();
    const iconEntry = announcementIconMap[announcement.icon];
    const authorName = `${announcement.createdBy.firstName} ${announcement.createdBy.lastName}`;
    const formattedDate = new Date(announcement.createdAt).toLocaleDateString(
        i18n.language === "nb" ? "nb-NO" : "en-US",
        { day: "numeric", month: "short", year: "numeric" },
    );

    return (
        <Button
            variant="submit"
            type="button"
            onClick={() => onClick(announcement)}
            className="group flex h-auto w-full items-center justify-start gap-3 whitespace-normal rounded-none border-b border-compendia-border bg-compendia-greige-10 px-4 py-3 text-left last:border-b-transparent hover:bg-compendia-greige-20"
        >
            <div className="flex size-8 shrink-0 items-center justify-center rounded-[3px] border border-compendia-border bg-compendia-greige-40 text-compendia-muted">
                <FontAwesomeIcon icon={iconEntry.icon} className="size-4" />
            </div>
            <div className="min-w-0 flex-1">
                <p className="truncate text-label font-medium text-compendia-foreground">
                    {announcement.title}
                </p>
                <div className="flex min-w-0 items-center gap-2 text-[11px] font-normal text-compendia-muted">
                    <span className="min-w-0 flex-1 truncate">
                        {formattedDate} · {authorName}
                    </span>
                    <AnnouncementReactionPreview
                        id={announcement.id}
                        reactionCounts={announcement.reactionCounts}
                    />
                </div>
            </div>
            <FontAwesomeIcon
                icon={faChevronRight}
                className="size-3 shrink-0 text-compendia-muted opacity-40 transition-opacity group-hover:opacity-100"
            />
        </Button>
    );
}
